"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LockCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 .99 1h4.02c.55 0 .99-.44.99-1v-2a1 1 0 0 0-1-1z"/></g></svg>`
}, props));
LockCircleIcon.displayName = 'LockCircleIcon';
var _default = exports.default = LockCircleIcon;